<template>
    <div class="page-content">
        <h3 class="title mb-4 mt-n2">Invoice Drafts Page</h3>
        <div class="row">
            <div class="col-xl-7 col-lg-7 partners_top_menu_section_hp mb-n4">
                <div class="row">
                    <div class="col-3">
                        <button class="w-100 btn btn-outline-primary" :class="{ active: activeTab === 'invoice' }"
                            @click="activeTab = 'invoice'">
                            Invoice Logs
                        </button>
                    </div>
                    <div class="col-3">
                        <button class="w-100 btn btn-outline-primary" :class="{ active: activeTab === 'pending' }"
                            @click="activeTab = 'pending'">
                            Pending Logs
                        </button>
                    </div>
                    <div class="col-3">
                        <button class="w-100 btn btn-outline-primary fs-bolder"
                            :class="{ active: activeTab === 'create' }" @click="activeTab = 'create'">
                            Create Invoices
                        </button>
                    </div>
                    <div class="col-3">
                        <button class="w-100 btn btn-outline-primary" :class="{ active: activeTab === 'usage' }"
                            @click="activeTab = 'usage'">
                            Client Usage
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Conditional Rendering of Components -->
        <div class="mt-n5" v-if="activeTab === 'create'">
            <CreateInvoices />
        </div>
        <div v-if="activeTab === 'invoice'">
            <InvoiceLogs />
        </div>
        <div v-if="activeTab === 'pending'">
            <PendingLogs />
        </div>
        <div v-if="activeTab === 'usage'">
            <ClientUsage />
        </div>
    </div>
</template>
<script>
import CreateInvoices from "../Invoices/CreateInvoices.vue";
import PendingLogs from "../Invoices/PendingLogs.vue";
import InvoiceLogs from "../Invoices/InvoiceLogs.vue";
import ClientUsage from '../Invoices/ClientUsage'

export default {
    name: "InvoiceDraftSetting",
    components: {
        CreateInvoices,
        InvoiceLogs,
        PendingLogs,
        ClientUsage
    },
    data() {
        return {
            activeTab: "invoice", // Default tab
        };
    },
}
</script>